'use client';

import {
  Drawer,
  Portal,
  DrawerHeader,
  DrawerFooter,
  drawerProps,
  DrawerBody
} from 'components/pcc-components';
import { CatHeading } from 'components/blocks-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useTranslations } from 'next-intl';
import ProductSpecsMobileDrawerContent from './product-specs-mobile-drawer-content/product-specs-mobile-drawer-content';
import ProductSpecsMobileDrawerFooter from './product-specs-mobile-drawer-footer';

export interface ProductSpecsMobileDrawerProps {
  closeDrawer: () => void;
  drawerProps: drawerProps;
  unitOfMeasure?: string;
}

export default function ProductSpecsMobileDrawer({
  closeDrawer,
  drawerProps,
  unitOfMeasure,
  ...additionalProps
}: Readonly<ProductSpecsMobileDrawerProps>) {
  const t = useTranslations();

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer
        {...drawerProps}
        data-testId="product-specs-mobile-drawer"
        position="right"
        onBlDrawerClose={closeDrawer}
        hasBackdrop
      >
        <DrawerHeader>
          <CatHeading variant="title-sm">
            {t('PRODUCT_SPECIFICATIONS')}
          </CatHeading>
        </DrawerHeader>
        <DrawerBody>
          <ProductSpecsMobileDrawerContent
            {...additionalProps}
            unitOfMeasure={unitOfMeasure}
          />
        </DrawerBody>
        <DrawerFooter className="d-flex gap-3">
          <ProductSpecsMobileDrawerFooter {...additionalProps} />
        </DrawerFooter>
      </Drawer>
    </Portal>
  );
}
